import quasarInstall from 'quasar/src/install.js'
import { version } from 'quasar/package.json'

import * as components from 'quasar/src/components.js'
import * as directives from 'quasar/src/directives.js'
import * as _plugins from 'quasar/src/plugins.js'
import * as utils from 'quasar/src/utils.js'
import lang from 'quasar/src/lang.js'
import iconSet from 'quasar/src/icon-set.js'

// eslint-disable-next-line no-import-assign
const { ...plugins } = _plugins

export function install (Vue, config = {}) {
  Vue.use({ install: quasarInstall }, {
    components,
    directives,
    plugins,
    config
  })
}

export default {
  version,
  lang,
  iconSet,
  components,
  directives,
  plugins,
  utils,
  ...components,
  ...directives,
  ...plugins,
  ...utils
}
